import http from '@/utils/http';
import { TIPS_VIEW_STATE_KEYS, TIPS_VIEW_STATE_KEY_MAP } from '@user-center/_config/tipsViewState';
import { YEAR_REPORT_NEW_TAG_END_DATE } from '@user-center/_config/yearReport';

export const MOCK_MENUS: IMenuItem[] = [
  {
    status: '1',
    icon: 'icon-year',
    rank: 1002,
    create_time: '2026-01-08 00:00:00',
    update_time: '2026-01-08 00:00:00',
    env: ['pre', 'pro'],
    id: '9997',
    parentMenuId: '0',
    type: '1',
    defaultOpened: false,
    title: 'Annual Review 2025',
    titleCN: '2025年度回顾',
    path: 'year-report',
    className: '',
    params: {
      path: 'year-report',
    },
    showNew: Date.now() < new Date(YEAR_REPORT_NEW_TAG_END_DATE).getTime(),
    subMenus: [],
    tag: {},
  },
  {
    status: '1',
    // TODO: 更新User Data Center菜单图标
    icon: 'market-reports',
    rank: 1001,
    create_time: '2025-08-01 16:51:21',
    update_time: '2025-08-01 14:18:31',
    env: ['pre', 'pro'],
    id: '9998',
    parentMenuId: '0',
    type: '1',
    defaultOpened: false,
    title: 'Your DataBrain MBTI',
    titleCN: '你的DataBrain MBTI',
    path: 'user-data-center/quarter-report',
    className: '',
    params: {
      path: 'user-data-center/quarter-report',
    },
    // showNew: false, // 改为动态控制
    tag: {},
    subMenus: [],
  },
  {
    status: '1',
    icon: 'datalab-list',
    rank: 1000,
    create_time: '2025-08-01 16:51:21',
    update_time: '2025-08-01 14:18:31',
    env: ['pre', 'pro'],
    id: '9999',
    parentMenuId: '0',
    type: '1',
    defaultOpened: false,
    title: 'Content Management Center',
    titleCN: '内容管理中心',
    path: 'content-management-center/reports',
    className: '',
    params: {
      path: 'content-management-center/reports',
    },
    tag: {},
    subMenus: [],
  },
  {    
    status: '1',    
    icon: 'lingpaiguanli',    
    rank: 1000,    
    create_time: '2026-03-18 00:00:00',    
    update_time: '2026-03-18 00:00:00',    
    env: ['pre', 'pro'],    
    id: '10000',    
    parentMenuId: '0',    
    type: '1',    
    defaultOpened: false,    
    title: 'Personal Token Center',    
    titleCN: '个人令牌中心',    
    path: 'personal-tokens-center',    
    className: '',    
    params: {      
    path: 'personal-tokens-center',    
    },    
    tag: {},    
    subMenus: [],  
    },
    
];

export const fetchMenus = (_params?: IRecord): IBaseResponse<IMenuItem[] | null> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const res = {
        code: 0,
        msg: '',
        req: {},
        data: MOCK_MENUS,
      };
      resolve(res);
    }, 30);
  });

  // return http({
  //   url: '',
  //   method: 'post',
  //   data: params,
  //   rawData: true,
  // }) as any;
};

export const fetchClassifiedOrganizations = (params: any) => {
  return http({
    url: '/api/v1/intelligence_pc/user/report/class/group',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;
};

export const fetchUserInformation = (params: { username: string }): IBaseResponse<IUserInformation | null> => {
  return http({
    url: '/api/v1/intelligence_pc/user/information',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;
};

export const covertToImageDataURL = (params: { imgs: string[] }): IBaseResponse<{ base64: string[] }> => {
  return http({
    url: '/api/v1/intelligence_pc/report/auto/base64',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;
};

interface IFetchOptionParams {
  action: 'get';
  keys: string[];
}

interface IUpdateOptionParams {
  action: 'set';
  key: string;
  value: string;
}

export const fetchOrUpdateOption = (
  params: IFetchOptionParams | IUpdateOptionParams,
): IBaseResponse<IRecord<string>> => {
  return http({
    method: 'post',
    url: '/api/v1/intelligence_pc/user/option',
    data: params,
    rawData: true,
  }) as any;
};

/**
 * 获取提醒查看状态
 */
export const fetchTipsViewState = async (params: { keys?: string[] | null }): IBaseResponse<IRecord<boolean>> => {
  const res = await fetchOrUpdateOption({
    action: 'get',
    keys: params?.keys || [],
  });

  const data = res?.data || {};
  const map: IRecord<boolean> = {};

  Object.entries(data).forEach(([key, value]) => {
    if (TIPS_VIEW_STATE_KEYS.includes(key)) {
      map[key] = value === 'true';
    }
  });

  return { ...res, data: map };
};

/**
 * 设置提醒已查看
 */
export const setTipsViewStateTrue = (params: { key: string }): IBaseResponse => {
  return fetchOrUpdateOption({
    action: 'set',
    key: params?.key || '',
    value: 'true',
  });
};
